export default {
  anonymous: () => import("/home/node/apps/claimant-portal-ui/layouts/anonymous.vue").then(m => m.default || m),
  auth: () => import("/home/node/apps/claimant-portal-ui/layouts/auth.vue").then(m => m.default || m),
  blank: () => import("/home/node/apps/claimant-portal-ui/layouts/blank.vue").then(m => m.default || m),
  dashboard: () => import("/home/node/apps/claimant-portal-ui/layouts/dashboard.vue").then(m => m.default || m),
  default: () => import("/home/node/apps/claimant-portal-ui/layouts/default.vue").then(m => m.default || m),
  error: () => import("/home/node/apps/claimant-portal-ui/layouts/error.vue").then(m => m.default || m)
}